import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import useUnmount from './useUnmount';

function useSetupTimeline<T>(
  setupTimelineMethod: (timeline: gsap.core.Timeline, refs: T) => void,
  refs: T,
): gsap.core.Timeline {
  const timeline = useRef<gsap.core.Timeline>(gsap.timeline({ paused: true }));
  const savedRefs = useRef(refs);

  useEffect(() => {
    setupTimelineMethod(timeline.current, savedRefs.current);
  }, [setupTimelineMethod, savedRefs]);

  useUnmount(() => {
    timeline?.current?.kill();
  });

  return timeline.current;
}

export default useSetupTimeline;
